var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pagination",
    class: _vm.isMobile && 'wap'
  }, [_c('ul', {
    staticClass: "pager clear",
    on: {
      "click": _vm.onPage
    }
  }, [_c('li', {
    staticClass: "pn prev hover",
    class: {
      disabled: _vm.page <= 1
    },
    attrs: {
      "aria-disabled": _vm.page <= 1,
      "arial-label": _vm.arialLabel(-1),
      "tabindex": "0",
      "data-page": "-1",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "arrow hover"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-arrow"
    }
  }), _vm._v(" " + _vm._s(_vm.tag) + " " + _vm._s(_vm.page <= 1 ? 0 : (_vm.page - 2) * _vm.pageSize) + " - " + _vm._s((_vm.page - 1) * _vm.pageSize) + " ")], 1)]), _c('div', {
    staticClass: "info"
  }, [_vm._v("Showing " + _vm._s((_vm.page - 1) * _vm.pageSize + 1) + " - " + _vm._s(_vm.page * _vm.pageSize))]), _c('li', {
    staticClass: "pn next hover",
    class: {
      disabled: _vm.page >= _vm.pages
    },
    attrs: {
      "aria-disabled": _vm.page >= _vm.pages,
      "arial-label": _vm.arialLabel(0),
      "tabindex": "0",
      "data-page": "0",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "arrow hover"
  }, [_vm._v(" " + _vm._s(_vm.tag) + " " + _vm._s(_vm.page * _vm.pageSize) + " - " + _vm._s((_vm.page + 1) * _vm.pageSize) + " "), _c('svg-icon', {
    attrs: {
      "name": "icon-arrow"
    }
  })], 1)])]), _vm.showSizes ? _c('div', {
    staticClass: "page-size"
  }, [_c('div', {
    staticClass: "page-select",
    on: {
      "mouseenter": function ($event) {
        _vm.showPageList = true;
      },
      "mouseleave": function ($event) {
        _vm.showPageList = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.pageSize) + " "), _vm.showPageList ? _c('div', {
    staticClass: "select-box"
  }, _vm._l(_vm.pageSizeList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "seleclt-opotion",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.onSize(item);
        }
      }
    }, [_vm._v(_vm._s(item))]);
  }), 0) : _vm._e()])]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };